<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <EditWSU title="กรุณากรอกข้อมูล"></EditWSU>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditWSU from "./EditWSU";
export default {
  name: "customerWsuDetail",
  components: {
    EditWSU,
  },
};
</script>
<style scoped></style>
